// extracted by mini-css-extract-plugin
export var optionGrid = "_8l-7";
export var optionList = "_8l-6";
export var questionsBlock = "_8l-9";
export var spacer = "_8l-5";
export var stepCenteredContent = "_8l-3";
export var stepInner = "_8l-0";
export var stepInnerFullWidth = "_8l-1";
export var stepInnerLockScroll = "_8l-2";
export var stepTransitionFrame = "_8l-4";
export var welcomeBlock = "_8l-8";